import { FunctionComponent, PropsWithChildren } from "react";

import { OverlayControlWrapper } from "./overlay-control.styles";

const OverlayControl: FunctionComponent<PropsWithChildren> = ({ children }) => {
  return <OverlayControlWrapper>{children}</OverlayControlWrapper>;
};

export default OverlayControl;
